
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('#dynacap-configurator');
  const configUrl = container?.dataset.configUrl;

  if (!configUrl) return;

  // Step 1: Load config
  fetch(configUrl)
    .then(r => r.json())
    .then(d => {
      console.log('CONFIG LOADED:', d);
      window.dynacapConfig = d;
      initializeConfigurator();
    })
    .catch(err => console.error('CONFIG LOAD ERROR:', err));

  // Step 2: Load variant map
  const variantMapUrl = container?.dataset.variantMapUrl;
  fetch(variantMapUrl)
    .then(r => r.json())
    .then(d => {
      console.log('VARIANT MAP LOADED:', d);
      window.dynacapVariantMap = d;

      const inventoryIds = Object.values(d.variant_map)
        .map(v => (typeof v === 'object' ? v.inventory_id : null))
        .filter(Boolean);

      fetchInventoryLevels(inventoryIds);
    })
    .catch(err => console.error('VARIANT MAP LOAD ERROR:', err));

  // Step 3: Fetch inventory levels
  function fetchInventoryLevels(inventoryIds) {
    if (!inventoryIds || inventoryIds.length === 0) return;

    // Chunk into batches of 50
    const batchedIds = [];
    for (let i = 0; i < inventoryIds.length; i += 50) {
      batchedIds.push(inventoryIds.slice(i, i + 50));
    }

    window.inventoryCache = {};

    Promise.all(
      batchedIds.map(batch => {
        const ids = batch.join(',');
        return fetch(`https://dynacap-inventory-api.vercel.app/api/inventory?variant_ids=${ids}`, {
  method: 'GET',
  mode: 'cors',
})
  .then(r => r.json())
  .then(data => {
    for (const inventoryId in data) {
      window.inventoryCache[inventoryId] = data[inventoryId];
    }
  })
  .catch(err => console.error('INVENTORY FETCH ERROR:', err));
      })
    ).then(() => {
      console.log('INVENTORY CACHE LOADED:', window.inventoryCache);
    });
  }

  function initializeConfigurator() {
    // Configurator logic will go here (already implemented earlier)
    console.log('Configurator initialized');
  }
});
